import { useCallback } from 'react';
import { uploadAttachApi } from '@services/Eha';
import config from '@config';
import RichEditor from '@components/common/RichEditor';

/** 健康号解决方案编辑：附件上传接口 */
const TinymceEditor = ({ form, fieldValue, initialValue, id, placeholder }) => {
    const getFileUrl = useCallback(url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return `${config.OSS_PREFIX}/${url}`;
        }
        return null;
    }, []);

    const imageUploadHandler = useCallback(
        async blobInfo => {
            const formData = new FormData();
            formData.append('file', blobInfo.blob());
            formData.append('path', '');

            const res = await uploadAttachApi(formData);
            if (res && res.data) {
                return getFileUrl(res.data);
            }
        },
        [getFileUrl],
    );

    const handleChange = useCallback(
        html => {
            const fieldVal = html === '' ? undefined : html;
            form.setFieldValue(fieldValue, fieldVal);
            if (fieldVal) {
                form.setFields([{ name: fieldValue, errors: null }]);
            }
        },
        [form, fieldValue],
    );

    if (!id) {
        return null;
    }

    return <RichEditor id={id} mode="full" height={300} placeholder={placeholder} value={initialValue ?? ''} onChange={handleChange} imageUploadHandler={imageUploadHandler} />;
};

export default TinymceEditor;
